module.exports = __webpack_public_path__ + "static/media/logo_autofact_blanco.2e6fa035.svg";